import { useAuth } from "../../context/AuthContext"
import { useNavigate, Link } from "react-router-dom"
import './login.css'
import './style.css'
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, MEDIA_BASE_URL } from "../../Helpers/apiConfig";


export default function ResetPasswordVerify() {
    const navigate = useNavigate()
    const { t, i18n } = useTranslation();
    const [msg, setMsg] = useState([]);
    const verify = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false'
            }
            let url = `${API_BASE_URL}/User/ResetPassword`;
            await axios({
                method: 'Post',
                url: url,
                data: {
                    hash: document.getElementById("hash").value,
                    username: document.getElementById("email").value,
                    newPassword: document.getElementById("loginpass").value,
                    newPasswordVerify: document.getElementById("loginpassverify").value,
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setMsg("Doğrulandı");
                        window.location.href = "/auth/login";
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
    }
    return (
        <div class="container-fluid h-custom">

            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-md-9 col-lg-6 col-xl-5">
                    <img src={MEDIA_BASE_URL + "/photo/8f973784-5f77-4ae5-b40e-dc5f9f93c4ed.png"}
                        class="img-fluid" alt="Sample image" />
                </div>

                <div class="col-md-8 col-lg-6 col-xl-4 offset-xl-1" id="registerForm" >
                    <form onSubmit={verify}>
                        <div class="divider d-flex align-items-center my-4">
                            <h2 class="text-center fw-bold mx-3 mb-0">
                                {t("resetpasswordVerifyTitle")}
                            </h2>
                        </div>
                        <h3>{msg}</h3> <br />
                        <div class="form-outline mb-3">
                            <label class="form-label" for="hash">{t("verifyHash")}</label>
                            <textarea type="name" id="hash" name="hash" class="form-control form-control-lg"
                                placeholder={t("verifyHash")} required rows={1} />
                        </div>

                        <div class="form-outline mb-3">
                            <label class="form-label" for="hash">{t("emailaddress")}</label>
                            <textarea type="name" id="email" name="email" class="form-control form-control-lg"
                                placeholder={t("emailaddress")} required rows={1} />
                        </div>
                        <div class="form-outline mb-3">
                            <label class="form-label" for="loginpass">Yeni Şifrenizi Giriniz</label>
                            <input type="password" id="loginpass" class="form-control form-control-lg"
                                placeholder="Yeni Şifrenizi Giriniz" required />
                        </div>
                        <div class="form-outline mb-3">
                            <label class="form-label" for="loginpassverify">Yeni Şifrenizi Tekrar Giriniz</label>
                            <input type="password" id="loginpassverify" class="form-control form-control-lg"
                                placeholder="Yeni Şifrenizi Tekrar Giriniz" required />
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-success btn-lg" style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}> Şifreyi Yenile</button>

                        </div>
                    </form>

                    <br /><br />

                </div>
            </div>

        </div>
    )
}